import { HTTPAUTH } from "../lib/httplib"

const state = {
  cash_history: {},
  loading: false,
}

const mutations = {
  set_cash_history (state, history) {
    state.cash_history = history
  },
  set_loading (state, loading) {
    state.loading = loading
  }
}

const actions = {
  pettycash_cash_history (context, data) {
    context.commit('set_loading', true)
    HTTPAUTH.get(`/api/v1/petty-cash-transaction?page=${data.page}&size=10&q=${data.q}`)
      .then((resp) => {
        context.commit('set_cash_history', resp.data)
        context.commit('set_loading', false)
      }).catch(() => {
        context.commit('set_loading', false)
      });
  },
}

const getters = {
}

export default {
  state, getters, mutations, actions
}